<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-md-8">
            <h3 class="mt-1">{{ product.name }}</h3>

            <h5>
              <span class="badge badge-secondary mr-2">
                {{ product.code }}
              </span>

              <span v-if="product.is_active == 1" class="badge badge-success">Active</span>
              <span v-if="product.is_active == 0" class="badge badge-danger">Obsolete</span>
              <span v-if="product.is_active == 2" class="badge badge-warning">On Hold</span>
            </h5>

            <div class="my-3" v-if="userHasPerms(['Manage products'])">
              <router-link
                           v-b-tooltip.hover
                           title="Edit"
                           :to="{
                            name: 'products-edit',
                            params: { id: product.id },
                          }"
                           class="text-primary table-action-icon ml-0">
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                    v-b-tooltip.hover
                    style="cursor: pointer"
                    title="Delete"
                    @click="confirmDelete(product.id)"
                    class="text-danger table-action-icon">
                <i class="lni lni-trash"></i>
              </span>
            </div>

            <div class="border w-50 p-2 float-left">
              <small class="text-muted">MIN (Mandate)</small>
              <h4 class="font-weight-bold">
                {{ product.mandate_pricing_min | currency }}
              </h4>
            </div>
            <div
                 class="border w-50 p-2 float-left"
                 v-show="product.mandate_pricing_max">
              <small class="text-muted">MAX (List Price)</small>
              <h4 class="font-weight-bold">
                {{ product.mandate_pricing_max | currency }}
              </h4>
            </div>
          </div>
          <div class="col-md-4 text-center text-md-right">
            <v-lazy-image
                          v-if="product.image"
                          :src="product.image"
                          class="img-fluid maxHeight200 mb-2" />
          </div>
        </div>

        <b-tabs class="mt-3">
          <b-tab title="Details">
            <table class="table table-sm mt-2">
              <table-row
                         label="Description"
                         :noBorder="true"
                         v-if="product.description">{{ product.description }}</table-row>

              <table-row label="Group">{{ product.product_group.name }}
              </table-row>

              <table-row label="Supplier">{{ product.supplier.name }}
              </table-row>

              <table-row label="Brand">{{ product.brand.name }} </table-row>

              <table-row label="Vatable">
                <b-form-checkbox
                                 style="margin-top: -7px"
                                 :disabled="true"
                                 v-model="product.is_vatable"
                                 value="1"
                                 unchecked-value="0"
                                 switch />
              </table-row>

              <table-row label="Price Extended By Mass">
                <b-form-checkbox
                                 style="margin-top: -7px"
                                 :disabled="true"
                                 v-model="product.price_extended_by_mass"
                                 value="1"
                                 unchecked-value="0"
                                 switch />
              </table-row>
              <table-row label="Average Mass" v-if="product.average_mass">{{ product.average_mass }} </table-row>

              <table-row label="Cases Per Pallet">{{ product.cases_per_pallet }}
              </table-row>

              <table-row label="Promote">
                <b-form-checkbox
                                 style="margin-top: -7px"
                                 :disabled="true"
                                 v-model="product.on_promotion"
                                 value="1"
                                 unchecked-value="0"
                                 switch />
              </table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">{{ product.id }} </table-row>

              <table-row label="Created">{{
                moment(new Date(product.created_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
              </table-row>
              <table-row label="Updated">{{
                moment(new Date(product.updated_at)).format(
                  "DD MMM YYYY, HH:mm:ss"
                )
              }}
              </table-row>
            </table>
          </b-tab>
          <b-tab title="Comments" :active="commentsTabActive">
            <div class="row my-5">
              <div class="col-12">
                <div class="border">
                  <div v-if="loading">
                    <b-spinner
                               variant="primary"
                               style="width: 3rem; height: 3rem"
                               label="Large Spinner"></b-spinner>
                  </div>

                  <div
                       v-for="comment in product.product_comments"
                       :key="comment.id"
                       class="card border-bottom p-2 mb-1">
                    <p class="nl2br">
                      {{ comment.comment }}
                    </p>

                    <a
                       v-if="comment.file_url"
                       :href="comment.file_url"
                       target="new">
                      {{ comment.file_description }}<br />
                    </a>

                    <img
                         v-if="comment.image"
                         :src="comment.image"
                         class="img-fluid maxWidth500 my-2" />

                    <div class="row">
                      <div class="col-auto">
                        <b-avatar v-if="!comment.user.image"></b-avatar>
                        <b-avatar
                                  v-if="comment.user.image"
                                  :src="comment.user.image"></b-avatar>
                      </div>
                      <div class="col">
                        <h6 class="mb-0 mt-1 font-weight-bold">
                          {{ comment.user.name }}
                        </h6>
                        <small class="text-muted">
                          <i class="lni lni-calendar"></i>
                          {{
                            moment(new Date(comment.created_at)).format(
                              "DD MMM YYYY, HH:mm:ss"
                            )
                          }}

                          |

                          {{
                            moment
                              .duration(
                                moment(Date.now()).diff(
                                  moment(new Date(comment.created_at)),
                                  "seconds"
                                ),
                                "seconds"
                              )
                              .format("Y [year] D [day], H [hour &] m [min]")
                          }}
                          ago
                        </small>

                        <small
                               v-if="userHasPerms(['Manage products'])"
                               class="text-danger pointer float-right"
                               @click="deleteComment(comment)">Delete</small>
                      </div>
                    </div>
                  </div>

                  <form-base
                             v-if="userHasPerms(['Manage products'])"
                             :submit-status="submitStatus"
                             action="Comment"
                             :errors="errors"
                             :loading="loading"
                             v-on:handleSubmit="createComment">
                    <template v-slot:fields>
                      <form-group label="Comment" :required="true">
                        <textarea-autosize
                                           class="form-control"
                                           v-model="newComment.comment" />
                      </form-group>

                      <form-group label="Attachments">
                        <p
                           v-if="newComment.file_id != null"
                           class="text-success">
                          File Loaded <i class="lni lni-checkmark"></i>
                        </p>
                        <p
                           v-if="newComment.image_id != null"
                           class="text-success">
                          Image Loaded <i class="lni lni-checkmark"></i>
                        </p>
                        <b-button
                                  v-b-toggle.collapse-1
                                  variant="secondary"
                                  size="sm">Attach image or file</b-button>
                        <b-collapse id="collapse-1" class="mt-2">
                          <b-card>
                            <form-group label="Image" v-if="!fileUploading">
                              <image-upload
                                            :key="imageKey"
                                            @files-uploaded="
                                              newComment.image_id = $event;
                                            imageUploading = false;
                                            "
                                            @files-uploaded-started="imageUploading = true"
                                            :multiple="false"
                                            :imageCrop="false"
                                            :validationState="imageVstate"
                                            acceptedTypes="image/*"></image-upload>
                            </form-group>

                            <form-group label="File" v-if="!imageUploading">
                              <file-upload
                                           :key="fileComponentKey"
                                           @files-uploaded="
                                            newComment.file_id = $event;
                                          fileUploading = false;
                                          "
                                           @files-uploaded-started="fileUploading = true"
                                           :multiple="false" />
                              <small class="text-muted font-size-11">*Max file size is 16MB</small>
                            </form-group>
                          </b-card>
                        </b-collapse>
                      </form-group>
                    </template>
                  </form-base>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import productRepo from "@/api/repos/productRepo";
import tableRow from "@/components/common/TableRow";
import imageUpload from "@/components/common/ImageUpload";
import fileUpload from "@/components/common/FileUpload";
import formGroup from "@/components/common/FormGroup";
import formBase from "@/components/common/FormBase";

export default {
  props: ["id"],

  components: {
    tableRow,
    formBase,
    formGroup,
    imageUpload,
    fileUpload,
  },

  mounted() {
    this.getProduct();
  },

  data() {
    return {
      loading: false,
      product: {
        product_group: {},
        supplier: {},
        brand: {},
      },
      newComment: { image_id: null, file_id: null, comment: null },
      submitStatus: null,
      errors: null,
      imageUploading: false,
      imageKey: 1,
      fileComponentKey: 1,
      fileUploading: false,
      commentsTabActive: false,
    };
  },

  methods: {
    async getProduct() {
      try {
        this.loading = true;
        let { data } = await productRepo.get(this.id);
        this.product = data.product;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteProduct(id) {
      this.isBusy = true;
      try {
        await productRepo.delete(id);
        this.$emit("productUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the product.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteProduct(id) : false))
        .catch((error) => console.log(error));
    },
    async createComment() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newComment == null) {
        this.$root.$bvToast.toast("Enter comment", {
          title: "Errors on form data",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else if (this.imageUploading == true || this.fileUploading == true) {
        this.$root.$bvToast.toast("Wait for Image/File Upload", {
          title: "Errors on form",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          let { data } = await productRepo.comment(
            this.product,
            this.newComment
          );
          this.product = data.product;
          this.newComment = {
            image_id: null,
            comment: null,
          };
          this.imageKey++;
          this.fileComponentKey++;
          this.commentsTabActive = true;
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
    async deleteComment(comment) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the comment.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (confirm) => {
          if (confirm) {
            this.loading = true;
            this.submitStatus = "PENDING";

            try {
              let { data } = await productRepo.commentDelete(
                this.product,
                comment
              );
              this.product = data.product;

              this.commentsTabActive = true;
            } catch (error) {
              console.log(error);
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.$root.$bvToast.toast("Form Errors", {
                  title: "Errors on form data",
                  autoHideDelay: 3000,
                  variant: "danger",
                });
              } else {
                this.$root.$bvToast.toast("Something Went Wrong", {
                  title: error.response.data.message,
                  autoHideDelay: 3000,
                  variant: "danger",
                });
              }
            } finally {
              this.loading = false;
              this.submitStatus = null;
            }
          }
        })
        .catch((error) => console.log(error));
    },
  },

  computed: {
    imageVstate() {
      return null;
    },
  },
};
</script>
